import React, { useRef } from "react";
import { QuickPickProps } from './types';
import { QuickPick as QuickPickV2 } from './components/QuickPickV2';
import { Minimal } from "./components/Minimal";
import { QuickPickSkeleton } from './components/QuickPickSkeleton';
import { randomIdString } from "shared/src/utils/randomIdString";
import kebabCase from 'lodash/kebabCase';

export const QuickPick = (props: QuickPickProps ) => {
  if (props.skeleton) return <QuickPickSkeleton variant={props?.variant} animation={props?.animation} />

  const randStr = useRef<string>(randomIdString());
  const { title = "", editable } = props;
  const isEditable = "editable" in props && editable !== false;
  const id = `cui__quick-pick-${kebabCase(title)}-${randStr.current}`;
  if (props.variant === "minimal") return (
    <Minimal {...props} id={id} isEditable={isEditable} />
  )
  return (
    <QuickPickV2 {...props} id={id} isEditable={isEditable} />
  );
};

export default QuickPick;

